// Common
export const DRCR = "drCr";
export const AMOUNT = "amount";
export const COMMUNITY_ID = "communityId";
export const LINE_ITEMS = "lineItems";
export const HEADER = "header";
export const CHEQUE_NO = "checkNumber";
export const PAYMENT_DATE = "paymentDate";


// Invoice --------------------------------------------------------------------------
// Header
export const DOCUMENT_ID = "postDocumentHeaderId";
export const DOCUMENT_TYPE = "documentType";
export const VENDOR_NAME = "vendorName";
export const INVOICE_NUMBER = "invoiceNumber";
export const INVOICE_REFERENCE = "invoiceRef";
export const INVOICE_AMOUNT = "invoiceAmount";
export const INVOICE_CURRENCY = "invoiceCurrency";
export const APPROVED_AMOUNT = "approvedAmount";
export const PAYMENT_TERMS = "paymentTerms";
export const DUE_DATE = "dueDate";
export const INVOICE_DATE = "invoiceDate";
export const BASELINE_DATE = "baselineDate";
export const COMMENTS = "comments";

// Entry Line Item
export const GL_ACCOUNT_NUMBER = "glAccountNumber";
export const GL_ACCOUNT_DESCRIPTION = "glMasterName";
export const ALT_GL_ACCOUNT_ID = "alternativeAccountNumber";
export const UNIT = "numberOfUnits";
export const RATE_PER_UNIT = "ratePerUnit";
export const APPROVED_UNIT = "approvedUnits";
export const APPROVED_RATE_PER_UNIT = "approvedRatePerUnit";
export const APP_AMOUNT = "appAmount";
export const BUDGET_YEAR = "budgetYear";
export const BUDGET_MONTH = "budgetMonth";
export const BUDGET_START_MONTH = "budgetMonthStart";
export const BUDGET_END_MONTH = "budgetMonthEnd";
export const DIST_ZONE = 'distZoneId';
export const DIST_BLOCK = 'distBlockId';
export const DIST_PROPERTY = 'distPropertyId';
export const ITEM_TEXT = "itemText";

// gl Line Items
export const LINE_ID = "postDocumentLineItemId";
export const APPROVAL_STATUS = "approvalStatus";
export const APPROVAL_LEVEL = "approvalLevel";
export const POSTING_DATE = "postingDate";
export const CURRENCY = "currency";

// -----------------------------------------------------------------------------

// Payment ---------------------------------------------------------------------
export const BANK_ACCOUNT = "bankAccountGlId";
export const ACCOUNT_NAME = "accountName";
export const PAYMENT_AMOUNT = "paymentAmount";
export const BANK_CHARGES = "bankChargeAmount";
export const DEDUCTION_AMOUNT = "deductionAmount";
export const PAYABLE_AMOUNT = "payableAmount";
export const RESIDUAL_AMOUNT = "residualAmount";

// ------------------------------------------------------------------------------

// -- OB ------------------------------------------------------------------------
export const BILLING_MONTH_YEAR = "billingMonthYear";
export const TRANSACTION_TYPE = "transactionType";
export const PAYMENT_TERM = "paymentTerm";
export const POSTING_YEAR = "postingYear";
export const POSTING_MONTH = "postingPeriod";
// ------------------------------------------------------------------------------

// --- OA -----------------------------------------------------------------------
export const LINE_ITEM_TEXT = "lineItemText";
export const BANK_INFO = "bankInfo";
export const BANK_CONF = "bankConf";
export const SUB_LEDGER = "subledger"; // missing
export const COMBINE = "combine";
export const COMBINE_PROP = "combineProp";
export const CUSTOMER_ACC = "propertyOwnershipId"; // missing
export const PAYMENT_METHOD = "paymentMethod";
export const OFFSET_ACC = "offsetAccount";
export const CLEARING = "cleared";
export const OL_DATE = "oiDate";
export const OL_REF = "oiReference";
export const OL_DOC_LI = "oiDocLi";
export const OL_TOTAL = "oiTotal";
export const LINE_ITEM_TYPE = "lineItemType";
// ------------------------------------------------------------------------------

export const PAYMENT_BLOCK = "paymentBlock";
export const BLOCK_DATE = "blockDate";
export const BLOCK_BY = "blockBy";
export const ATTACHMENT = "attachment";
export const ATTACHMENT_ID = "attachmentId";
export const DOC_STATUS = "documentStatus";

export const vi = {
  header: [
    { key: DOCUMENT_TYPE, label: "Document Type", checked: true },
    { key: DOCUMENT_ID, label: "Document ID", checked: true },
    { key: VENDOR_NAME, label: "Vendor Name", checked: true },
    { key: INVOICE_NUMBER, label: "Invoice Number", checked: true },
    { key: INVOICE_DATE, label: "Invoice Date", checked: true },
    { key: BASELINE_DATE, label: "Baseline Date", checked: true },
    { key: INVOICE_REFERENCE, label: "Invoice Reference", checked: true },
    { key: INVOICE_AMOUNT, label: "Invoice Amount", checked: true },
    { key: APPROVED_AMOUNT, label: "Approved Amount", checked: true },
    { key: POSTING_DATE, label: "Posting Date", checked: true },
    { key: DUE_DATE, label: "Due Date", checked: true },
    { key: COMMENTS, label: "Header Text", checked: true },
  ],
  entryLineItems: [
    { key: GL_ACCOUNT_NUMBER, label: "GL Acct. Description", checked: true },
    { key: ITEM_TEXT, label: "Line Item Text", checked: true },
    { key: ALT_GL_ACCOUNT_ID, label: "AL GL Account", checked: true },
    { key: DRCR, label: "Dr/Cr", checked: true },
    { key: UNIT, label: "# Unit", checked: true },
    { key: RATE_PER_UNIT, label: "Rate Per Unit", checked: true },
    { key: AMOUNT, label: "Amount", checked: true },
    { key: APPROVED_UNIT, label: "# Approved Unit", checked: true },
    { key: APPROVED_RATE_PER_UNIT, label: "Approved Rate Per Unit", checked: true },
    { key: APP_AMOUNT, label: "Approved Amount", checked: true },
    { key: BUDGET_MONTH, label: "Budget Month/Year", checked: true },
    { key: DIST_ZONE, label: "Zone", checked: true },
    { key: DIST_BLOCK, label: "Block", checked: true },
    { key: DIST_PROPERTY, label: "Property ID", checked: true },
  ],
  glLineItem: [
    { key: LINE_ID, label: "Line ID", checked: false },
    { key: GL_ACCOUNT_NUMBER, label: "GL Acct. Description", checked: true },
    { key: ITEM_TEXT, label: "Line Item Text", checked: true },
    { key: ALT_GL_ACCOUNT_ID, label: "AL GL Account", checked: false },
    { key: DRCR, label: "Dr/Cr", checked: true },
    { key: UNIT, label: "# Unit", checked: true },
    { key: RATE_PER_UNIT, label: "Rate Per Unit", checked: true },
    { key: AMOUNT, label: "Amount", checked: true },
    { key: APPROVED_UNIT, label: "# Approved Unit", checked: true },
    { key: APPROVED_RATE_PER_UNIT, label: "Approved Rate Per Unit", checked: true },
    { key: APP_AMOUNT, label: "Approved Amount", checked: true },
    { key: BUDGET_MONTH, label: "Budget Month/Year", checked: true },
    { key: DIST_ZONE, label: "Zone", checked: true },
    { key: DIST_BLOCK, label: "Block", checked: true },
    { key: DIST_PROPERTY, label: "Property ID", checked: true },
    { key: APPROVAL_STATUS, label: "Approved", checked: false },
    { key: APPROVAL_LEVEL, label: "Approval Level", checked: false },
    { key: CURRENCY, label: "Currency", checked: false },
  ]
};

export const vp = {
  header: [
    { key: DOCUMENT_TYPE, label: "Document Type", checked: true },
    { key: DOCUMENT_ID, label: "Document ID", checked: true },
    { key: VENDOR_NAME, label: "Vendor Name", checked: true },
    { key: GL_ACCOUNT_NUMBER, label: "Bank Account", checked: true },
    { key: GL_ACCOUNT_DESCRIPTION, label: "Account Name", checked: true },
    { key: POSTING_DATE, label: "Posting Date", checked: true },
    { key: APPROVED_AMOUNT, label: "Payment Amount", checked: true },
    { key: CHEQUE_NO, label: "Cheque No", checked: true },
    { key: PAYMENT_DATE, label: "Payment Date", checked: true },
    { key: BANK_CHARGES, label: "Bank Charges", checked: true },
    { key: DEDUCTION_AMOUNT, label: "Deduction Amount", checked: true },
    { key: COMMENTS, label: "Header Text", checked: true },
  ],
  entryLineItems: [
    { key: INVOICE_DATE, label: "Invoice Date", checked: true },
    { key: INVOICE_NUMBER, label: "Invoice No.", checked: true },
    { key: INVOICE_REFERENCE, label: "Invoice Reference", checked: true },
    { key: DOCUMENT_ID, label: "Doc No.", checked: true },
    { key: DOCUMENT_TYPE, label: "Doc Type", checked: true },
    { key: ITEM_TEXT, label: "Line Item Text", checked: true },
    { key: BASELINE_DATE, label: "Baseline Date", checked: true },
    { key: DUE_DATE, label: "Due Date", checked: true },
    { key: DRCR, label: "Dr/Cr", checked: true },
    { key: INVOICE_AMOUNT, label: "Invoice Amount", checked: true },
    { key: APPROVED_AMOUNT, label: "Approved Amount", checked: true },
    { key: PAYABLE_AMOUNT, label: "Payable Amount", checked: true },
    { key: RESIDUAL_AMOUNT, label: "Residual Amount", checked: true },
  ],
  glLineItem: [
    { key: LINE_ID, label: "Line ID", checked: false },
    { key: INVOICE_DATE, label: "Invoice Date", checked: true },
    { key: INVOICE_NUMBER, label: "Invoice No.", checked: true },
    { key: INVOICE_REFERENCE, label: "Invoice Reference", checked: true },
    { key: DOCUMENT_ID, label: "Doc No.", checked: true },
    { key: DOCUMENT_TYPE, label: "Doc Type", checked: true },
    { key: ITEM_TEXT, label: "Header Text", checked: true },
    { key: BASELINE_DATE, label: "Baseline Date", checked: true },
    { key: DUE_DATE, label: "Due Date", checked: true },
    { key: DRCR, label: "Dr/Cr", checked: true },
    { key: INVOICE_AMOUNT, label: "Invoice Amount", checked: true },
    { key: APPROVED_AMOUNT, label: "Approved Amount", checked: true },
    { key: PAYABLE_AMOUNT, label: "Payable Amount", checked: true },
    { key: RESIDUAL_AMOUNT, label: "Residual Amount", checked: true },
    { key: CURRENCY, label: "Currency", checked: false },
  ]
};

export const ob = {
  header: [
    { key: DOCUMENT_TYPE, label: "Document Type", checked: true },
    { key: DOCUMENT_ID, label: "Document ID", checked: true },
    { key: BILLING_MONTH_YEAR, label: "Billing Month/Year", checked: true },
    { key: POSTING_DATE, label: "Posting Date", checked: true },
    { key: APPROVED_AMOUNT, label: "Billing Amount", checked: true },
    { key: DUE_DATE, label: "Due Date", checked: true },
    { key: TRANSACTION_TYPE, label: "Transaction Type", checked: true },
    { key: PAYMENT_TERM, label: "Payment Term", checked: true },
    { key: COMMENTS, label: "Header Text", checked: true },
  ],
  entryLineItems: [
    { key: GL_ACCOUNT_NUMBER, label: "GL Acct. Description", checked: true },
    { key: ITEM_TEXT, label: "Line Item Text", checked: true },
    { key: DRCR, label: "Dr/Cr", checked: true },
    { key: AMOUNT, label: "Billing Amount", checked: true },
  ],
  glLineItem: [
    { key: LINE_ID, label: "Line ID", checked: false },
    { key: GL_ACCOUNT_NUMBER, label: "GL Acct. Description", checked: true },
    { key: ITEM_TEXT, label: "Line Item Text", checked: true },
    { key: DRCR, label: "Dr/Cr", checked: true },
    { key: AMOUNT, label: "Billing Amount", checked: true },
    { key: CURRENCY, label: "Currency", checked: false },
  ]
};

export const oa = {
  header: [
    { key: DOCUMENT_TYPE, label: "Document Type", checked: true },
    { key: DOCUMENT_ID, label: "Document ID", checked: true },
    { key: BILLING_MONTH_YEAR, label: "Billing Month/Year", checked: true },
    { key: ATTACHMENT, label: "Uploaded File", checked: true },
    { key: POSTING_DATE, label: "Posting Date", checked: true },
    { key: COMMENTS, label: "Header Text", checked: true },
  ],
  entryLineItems: [
    { key: PAYMENT_DATE, label: "Date", checked: true },
    { key: CHEQUE_NO, label: "Cheque No", checked: true },
    { key: AMOUNT, label: "Amount", checked: true },
    { key: CURRENCY, label: "Currency", checked: false },
    { key: BANK_INFO, label: "Bank Info", checked: true },
    { key: BANK_CONF, label: "Bank Conf", checked: true },
    { key: DRCR, label: "Dr/Cr", checked: true },
    { key: GL_ACCOUNT_NUMBER, label: "GL Acct. Description", checked: true },
    { key: LINE_ITEM_TEXT, label: "Line Item Text", checked: true },
    { key: SUB_LEDGER, label: "Subledger", checked: true },
    { key: COMBINE, label: "Combine", checked: true },
    { key: CUSTOMER_ACC, label: "Customer A/c", checked: true },
    { key: PAYMENT_METHOD, label: "Payment Method", checked: true },
    { key: OFFSET_ACC, label: "Offset Acct", checked: true },
    { key: CLEARING, label: "Clearing", checked: true },
    { key: OL_DATE, label: "OI Date", checked: true },
    { key: OL_DOC_LI, label: "OI Ref(Doc/LI)", checked: true },
    { key: OL_REF, label: "OI Reference", checked: true },
  ],
  glLineItem: [
    { key: LINE_ID, label: "Line ID", checked: false },
    { key: PAYMENT_DATE, label: "Date", checked: true },
    { key: CHEQUE_NO, label: "Cheque No", checked: true },
    { key: AMOUNT, label: "Amount", checked: true },
    { key: CURRENCY, label: "Currency", checked: false },
    { key: BANK_INFO, label: "Bank Info", checked: true },
    { key: BANK_CONF, label: "Bank Conf", checked: true },
    { key: DRCR, label: "Dr/Cr", checked: true },
    { key: GL_ACCOUNT_NUMBER, label: "GL Acct. Description", checked: true },
    { key: LINE_ITEM_TEXT, label: "Line Item Text", checked: true },
    { key: SUB_LEDGER, label: "Subledger", checked: true },
    { key: COMBINE, label: "Combine", checked: true },
    { key: CUSTOMER_ACC, label: "Customer A/c", checked: true },
    { key: PAYMENT_METHOD, label: "Payment Method", checked: true },
    { key: OFFSET_ACC, label: "Offset Acct", checked: true },
    { key: CLEARING, label: "Clearing", checked: true },
    { key: OL_DATE, label: "OI Date", checked: true },
    { key: OL_DOC_LI, label: "OI Ref(Doc/LI)", checked: true },
    { key: OL_REF, label: "OI Reference", checked: true },
  ]
};

export const DOCUMENT_MAPPINGS = {
  vi: {
    gl: {
      [HEADER]: vi.header,
      [LINE_ITEMS]: vi.glLineItem,
    },
    entry: {
      [HEADER]: vi.header,
      [LINE_ITEMS]: vi.entryLineItems,
    },
  },
  vp: {
    gl: {
      [HEADER]: vp.header,
      [LINE_ITEMS]: vp.glLineItem,
    },
    entry: {
      [HEADER]: vp.header,
      [LINE_ITEMS]: vp.entryLineItems,
    },
  },
  ob: {
    gl: {
      [HEADER]: ob.header,
      [LINE_ITEMS]: ob.glLineItem,
    },
    entry: {
      [HEADER]: ob.header,
      [LINE_ITEMS]: ob.entryLineItems,
    },
  },
  oa: {
    gl: {
      [HEADER]: oa.header,
      [LINE_ITEMS]: oa.glLineItem,
    },
    entry: {
      [HEADER]: oa.header,
      [LINE_ITEMS]: oa.entryLineItems,
    },
  },
  other: {
    gl: {
      [HEADER]: vi.header,
      [LINE_ITEMS]: vi.glLineItem,
    },
    entry: {
      [HEADER]: vi.header,
      [LINE_ITEMS]: vi.entryLineItems,
    },
  },
};
